module.exports = __webpack_public_path__ + "media/images/home/sc3-0e50597988e20334511eb79194c1aa45.webp";